// components
import { IconButton } from '@mui/material';

import { Menu as MenuIcon } from '@mui/icons-material';
import { ListItemBase } from '../../../../../../components/Menus/ListItemBase';

import {
  MENU_TRIGGER_LABEL,
  SimpleMenu,
} from '../../../../../../components/Menus/SimpleMenu';
import { SubMenu } from '../../../../../../components/Menus/SubMenu';

// other
import { Modal } from '../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import { usePolicyActions } from '../../../../../../components/hooks/business-logic/policy-actions/usePolicyActions';
import { withShowable } from '../../../../../_global/lib/withShowable';
import { ApplyExternalPaymentConfig } from '../../../../../../components/modals/v2/payment/ApplyExternalPayment';

const ListItem = withShowable(ListItemBase);

export const CancelledPolicyDrawerActions = ({ data = {} }) => {
  const { handleApplyPayment } = useHandlers(data);

  // @ts-expect-error TS(2345): Argument of type '{}' is not assignable to paramet... Remove this comment to see the full error message
  const policyActions = usePolicyActions(data);

  return (
    <SimpleMenu
      id="cancelled-policy-drawer-actions"
      anchor={
        <IconButton size="small" aria-label={MENU_TRIGGER_LABEL}>
          <MenuIcon />
        </IconButton>
      }
      minWidth="19rem"
    >
      <SubMenu closeMenu header="Payments" show>
        <ListItem
          show={
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            policyActions.CAN_APPLY_PAYMENT || policyActions.CAN_ISSUE_REFUND
          }
          onClick={handleApplyPayment}
          name="Apply Payment/Refund"
        />
      </SubMenu>
    </SimpleMenu>
  );
};

function useHandlers(data: any) {
  const handleApplyPayment = () => {
    Modal.show(ApplyExternalPaymentConfig, { data });
  };

  return { handleApplyPayment };
}
